<template lang="pug">
.views-container
  gb-side-menu
  .content-area
    div(style="display:flex;justify-content:space-between")
      h3 {{ $route.params.childNameValue }} れんらくノート
      div
        gb-button.effect(@clicked="toggleSearchModal(true)") 日にち検索
        gb-button.effect(@clicked="backToNote") 園児詳細
    transition(name="fade")
      template(v-if="isShowSearchModal")
        gb-mask(:show="true")
          .gb-card-cancel.disable-card
            .cancel-box(@click="toggleSearchModal(false)")
              p.cancel-bottom ×
            .input-wrapper
              label.label 日にち
              datepicker(:format="DatePickerFormat",:language="ja", @selected="selectedDatePicker")
            div(style="height: 30px")
    div(style="display:flex;margin-bottom:20px;")
      p.menu-icon(@click="fetchContactBook('yesterday')") ＜
      h3(style="margin:0") {{ displayDate }}
      p.menu-icon(@click="fetchContactBook('tomorrow')") ＞
    .card-wrapper
      .card
        p 家庭での様子
        div.space-around
          h6.title-label(style="margin:16px 0px 8px;font-size:14px;") 睡眠時間
          div
            h6.result-label(
              v-for="(sFrom, index) in hSleepFrom",
              v-if="sFrom !== 'NO_CONTENTS'",
              style="margin:16px 0px 8px;font-size:14px;"
            ) {{ sFrom }} 〜 {{hSleepEnd[index]}} {{ hSleepTotal[index] }}
        div.space-around
          h6.title-label(style="margin:8px 0px 8px;font-size:14px;") 体温
          div
            h6.result-label(
              v-for="(temperature, index) in hTemperature",
              v-if="temperature !== 'NO_CONTENTS'",
              style="margin:16px 0px 8px;font-size:14px;"
            ) {{ temperature }}  {{hTemperatureTime[index]}}
        div.space-around
          h6.title-label(style="margin:8px 0px;font-size:14px;") 夕食
          div
            h6.result-label(
              v-if="hDinner !== 'NO_CONTENTS'",
              style="margin:8px 0px;font-size:14px;"
            ) {{ hDinner }}
        div.space-around
          h6.title-label(style="margin:8px 0px;font-size:14px;") 朝食
          div
            h6.result-label(
              v-if="hBreakfast !== 'NO_CONTENTS'",
              style="margin:8px 0px;font-size:14px;"
            ) {{ hBreakfast }}
        div.space-around
          h6.title-label(style="margin:8px 0px;font-size:14px;") ミルク
          div
            h6.result-label(
              v-for="(milk, index) in hMilk",
              v-if="milk !== 'NO_CONTENTS'",
              style="margin:8px 0px;font-size:14px;"
            ) {{ milk }}  {{ hMilkTime[index] }}
        div.space-around
          h6.title-label(style="margin:8px 0px;font-size:14px;") 排便
          div
            h6.result-label(
              v-for="(defecation, index) in hDefecation",
              v-if="defecation !== 'NO_CONTENTS'",
              style="margin:8px 0px;font-size:14px;"
            ) {{ defecation }} {{ hDefecationTime[index] }}
      .card
        p 園での様子
        div.space-around
          h6.title-label(style="margin:16px 0px 8px;font-size:14px;") 午睡時間
          div
            h6.result-label(
              v-for="(sleepFrom, index) in sSleepFrom",
              v-if="sleepFrom !== 'NO_CONTENTS'",
              style="margin:16px 0px;font-size:14px;"
            ) {{ sleepFrom }} 〜 {{ sSleepEnd[index] }} {{ sSleepTotal[index] }}
        div.space-around
          h6.title-label(style="margin:8px 0px;font-size:14px;") 排便
          div
            h6.result-label(
              v-for="(defecationState, index) in sDefecationState",
              v-if="defecationState !== 'NO_CONTENTS'",
              style="margin:8px 0px;font-size:14px;"
            ) {{ defecationState }} {{ sDefecationTime[index] }}
        div.space-around
          h6.title-label(style="margin:8px 0px;font-size:14px;") 喫食状況
          div
            h6.result-label(
              v-for="(mealType, index) in sMealType",
              v-if="mealType !== 'NO_CONTENTS'",
              style="margin:8px 0px;font-size:14px;"
            ) {{ mealType }} {{ sMealAmount[index] }}
        div.space-around
          h6.title-label(style="margin:8px 0px;font-size:14px;") ミルク
          div
            h6.result-label(
              v-for="(milk, index) in sMilk",
              v-if="milk !== 'NO_CONTENTS' && sMilkTime[index] !== 'NO_CONTENTS'",
              style="margin:8px 0px;font-size:14px;"
            ) {{ milk }} {{ sMilkTime[index] }}
        div.space-around
          h6.title-label(style="margin:8px 0px;font-size:14px;") 体温
          div
            h6.result-label(
              v-for="(temperature, index) in sTemperature"
              v-if="temperature !== 'NO_CONTENTS'"
              style="margin:8px 0px;font-size:14px;"
            ) {{ temperature }} {{ sTemperatureTime[index] }}
      .card
        p 家庭コメント
        h6(
          v-if="hComment !== 'NO_CONTENTS'",
          style="margin:16px 8px;"
        ) {{ hComment }}
      .card(v-if="sComment !== null && sComment !== '' && sComment !== 'NO_CONTENTS'")
        p 園コメント
        h6(
          style="margin:16px 8px;"
        ) {{ sComment }}
      .card
        p お知らせ
        h6(
          v-if="sClassComment !== 'NO_CONTENTS'",
          style="margin:16px 8px;"
        ) {{ sClassComment }}
</template>
<script>
import util from '@/api/util'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'
import { Cache } from 'aws-amplify'

import GbSideMenu from '@/components/organisms/GbSideMenu.vue'
import GbButton from '@/components/atoms/GbButton.vue'
import GbInput from '@/components/atoms/GbInput.vue'
import GbMask from '@/components/atoms/GbMask.vue'

export default {
  components: {
    Datepicker,
    GbSideMenu,
    GbButton,
    GbInput,
    GbMask
  },
  data () {
    return {
      selectedDate: null,
      isShowSearchModal: false,
      displayDate: null,
      date: null,
      // 連絡ノート項目
      // 保護者
      createdAt: null,
      hSleepFrom: [],
      hSleepEnd: [],
      hSleepTotal: [],
      hTemperature: [],
      hTemperatureTime: [],
      hDinner: null,
      hBreakfast: null,
      hMilk: [],
      hMilkTime: [],
      hDefecation: [],
      hDefecationTime: [],
      hComment: null,
      // 保育士
      sDefecationState: [],
      sDefecationTime: [],
      sMealType: [],
      sMealAmount: [],
      sMilk: [],
      sMilkTime: [],
      sSleepFrom: [],
      sSleepEnd: [],
      sSleepTotal: [],
      sTemperature: [],
      sTemperatureTime: [],
      sComment: null,
      sClassComment: null,
      nurseId: null,
      nurseName: null,
      // vuejs-datepicker
      DatePickerFormat: 'yyyy-MM-dd',
      ja: ja
    }
  },
  beforeMount: async function () {
    const isMaintenance = (await util.checkMaintenance({type: 'admin'})).data.data.is_maintenance
    if (isMaintenance) {
      this.$swal.fire({
        html: `現在メンテナンス中です`
      }).then(() => {
        this.$router.push({ name: 'Maintenance' })
      })
    } else {
      util.createMethod('COG', 'checkSessionExpired', null)
        .then(response => {
          if (response) {
            this.$router.push({ name: 'SignIn' })
          } else {
            this.selectedDate = moment()
            this.fetchContactBook('today')
            Cache.clear()
          }
        })
    }
  },
  methods: {
    async fetchContactBook (date) {
      // 引数dateは 'today', 'tomorrow' 'yesterday'で振り分け
      // 検索の場合はそのまま使う
      let requestDate
      if (date === 'today') requestDate = moment().locale('ja').format('YYYY-MM-DD')
      else if (date === 'tomorrow') requestDate = moment(this.selectedDate).locale('ja').add(1, 'd').format('YYYY-MM-DD')
      else if (date === 'yesterday') requestDate = moment(this.selectedDate).locale('ja').subtract(1, 'd').format('YYYY-MM-DD')
      else requestDate = moment(date).format('YYYY-MM-DD')
      this.selectedDate = moment(requestDate).locale('ja')
      this.displayDate = moment(requestDate).locale('ja').format('YYYY-MM-DD(ddd)')
      const APPSYNC_REQUEST_VALUE = {
        child: this.$route.params.childId + '#' + this.$route.params.nurseryCode,
        createdAt: requestDate
      }
      try {
        const Response = (await util.createMethod('APPSYNC', 'fetchContactBook', APPSYNC_REQUEST_VALUE))
        if (Response.hSleepFrom) this.hSleepFrom = Response.hSleepFrom.split('#')
        if (Response.hSleepEnd) this.hSleepEnd = Response.hSleepEnd.split('#')
        if (Response.hSleepTotal) this.hSleepTotal = Response.hSleepTotal.split('#')
        if (Response.hTemperature) this.hTemperature = Response.hTemperature.split('#')
        if (Response.hTemperatureTime) this.hTemperatureTime = Response.hTemperatureTime.split('#')
        if (Response.hDinner) this.hDinner = Response.hDinner
        if (Response.hBreakfast) this.hBreakfast = Response.hBreakfast
        if (Response.hDefecation) this.hDefecation = Response.hDefecation.split('#')
        if (Response.hDefecationTime) this.hDefecationTime = Response.hDefecationTime.split('#')
        if (Response.hMilk) this.hMilk = Response.hMilk.split('#')
        if (Response.hMilkTime) this.hMilkTime = Response.hMilkTime.split('#')
        if (Response.hComment) this.hComment = Response.hComment
        // 保育園
        if (Response.sSleepFrom) this.sSleepFrom = Response.sSleepFrom.split('#')
        if (Response.sSleepEnd) this.sSleepEnd = Response.sSleepEnd.split('#')
        if (Response.sSleepTotal) this.sSleepTotal = Response.sSleepTotal.split('#')
        if (Response.sDefecationState) this.sDefecationState = Response.sDefecationState.split('#')
        if (Response.sDefecationTime) this.sDefecationTime = Response.sDefecationTime.split('#')
        if (Response.sMilk) this.sMilk = Response.sMilk.split('#')
        if (Response.sMilkTime) this.sMilkTime = Response.sMilkTime.split('#')
        if (Response.sMealType) this.sMealType = Response.sMealType.split('#')
        if (Response.sMealAmount) this.sMealAmount = Response.sMealAmount.split('#')
        if (Response.sTemperature) this.sTemperature = Response.sTemperature.split('#')
        if (Response.sTemperatureTime) this.sTemperatureTime = Response.sTemperatureTime.split('#')
        if (Response.sComment) this.sComment = Response.sComment
        if (Response.sClassComment) this.sClassComment = Response.sClassComment
        if (Response.nurseId) this.nurseId = Response.nurseId
        if (Response.nurseName) this.nurseName = Response.nurseName
        return true
      } catch (error) {
        this.hSleepFrom = []
        this.hSleepEnd = []
        this.hSleepTotal = []
        this.hTemperature = []
        this.hTemperatureTime = []
        this.hDinner = ''
        this.hBreakfast = ''
        this.hDefecation = []
        this.hDefecationTime = []
        this.hMilk = []
        this.hMilkTime = []
        this.hComment = ''
        // 保育園
        this.sSleepFrom = []
        this.sSleepEnd = []
        this.sSleepTotal = []
        this.sDefecationState = []
        this.sDefecationTime = []
        this.sMilk = []
        this.sMilkTime = []
        this.sMealType = []
        this.sMealAmount = []
        this.sTemperature = []
        this.sTemperatureTime = []
        this.sComment = ''
        this.sClassComment = ''
        this.nurseId = null
        this.nurseName = null
        this.$swal.fire({
          text: '対象日の記録はありません'
        })
      }
    },
    async selectedDatePicker (date) {
      try {
        const Response = (await this.fetchContactBook(date))
        if (Response) {
          this.toggleSearchModal(false)
        }
      } catch (error) {}
    },
    toggleSearchModal (isOpen) {
      if (isOpen) {
        this.isShowSearchModal = true
      } else {
        this.isShowSearchModal = false
      }
    },
    backToNote () {
      this.$router.push({
        name: 'ChildDetail',
        params: {nurseryCode: this.$route.params.nurseryCode, nurseryName: this.$route.params.nurseryName, childId: this.$route.params.childId}
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../stylus/main.styl'
.container
  width 100%
  min-height 100vh
  display flex
  flex-direction row
  justify-content flex-start

.card-wrapper
  max-width 980px
  margin 0 auto
  display flex
  justify-content flex-end
  flex-wrap wrap
  column-count 2

.card
  width 450px
  min-height 35vh
  border-radius 5px
  background-color white
  padding 20px
  margin 10px
.auth-card-layout
  width 100%
  height 100%
  display flex
  flex-direction column
  justify-content space-around
  align-items stretch
.gb-card-cancel
  background-color #fff
  border-radius 2px
  padding-top 0
  padding-right 0
  display flex
  align-items flex-end
.cancel-box
  width 50px
  height 50px
  border-bottom 1px solid #000
  border-left 1px solid #000
  display grid
  align-items center
.cancel-bottom
  font-size 30px
  text-align center
  font-weight 300
  cursor pointer
.disable-card
  width 680px
  height 400px
  display flex
  flex-direction column
  justify-content space-between
.logout
  margin 0 auto 50px
.label
  font-size 12px
  color $color-secondary
  margin 0 8px
.input-wrapper
  display flex
  flex-direction column
  justify-content center
  align-items stretch
  margin 8px auto
.note-content
  display flex
  //justify-content space-around
.input
  border none
  outline none
  height 30px
  width 400px
  border-radius 4px
  margin 8px
  padding 0 8px
  background-color $color-gray
  font-size 14px
  transition-duration .2s
  &:focus
    background-color #fff
    box-shadow 0 2px 4px rgba(42, 54, 63, 0.2)
h6
  color $color-secondary
  font-size 14px
.block
  display block
.title-block
  display block
  width 4vw
.text-block
  display block
  width 20vw
.space-around
  display flex
  // justify-content space-around
.menu-icon
  width 24px
  font-size 21px
  margin 0 20px
  color $color-secondary
  cursor pointer
.title-label
  width 70px
.result-label
  width 100%
</style>



// WEBPACK FOOTER //
// src/views/ChildNote.vue